import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: number | null;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  min?: number;
  max?: number;
  step?: number;
  precision?: number;
  controls?: boolean;
  status?: "" | "error" | "warning";
  formatter?: (value: number | string, info: { userTyping: boolean; input: string }) => string;
  parser?: (displayValue: string | undefined) => number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputNumberDefault',
  props: {
    modelValue: { default: null },
    placeholder: { default: "Nhập số" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    min: { default: undefined },
    max: { default: undefined },
    step: { default: 1 },
    precision: { default: undefined },
    controls: { type: Boolean, default: true },
    status: { default: "" },
    formatter: { type: Function, default: undefined },
    parser: { type: Function, default: undefined }
  },
  emits: ["update:modelValue", "blur", "pressEnter", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: number | null) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createBlock(_component_a_input_number, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    min: _ctx.min,
    max: _ctx.max,
    step: _ctx.step,
    precision: _ctx.precision,
    controls: _ctx.controls,
    status: _ctx.status,
    formatter: _ctx.formatter,
    parser: _ctx.parser,
    class: "ant-number-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, null, 8, ["value", "placeholder", "disabled", "size", "min", "max", "step", "precision", "controls", "status", "formatter", "parser"]))
}
}

})